
'use client';
import { useEffect, useState } from 'react';
import type { User } from 'firebase/auth';
import { useAuth } from '@/firebase/client-provider';


export function useUser() {
  const auth = useAuth();
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // onAuthStateChanged can call back immediately with the current user,
    // so we set loading to true initially.
    setLoading(true);
    if(auth) {
        const unsubscribe = auth.onAuthStateChanged((user) => {
          setUser(user);
          setLoading(false);
        });
        return () => unsubscribe();
    } else {
      // If auth is not ready, set user to null and stop loading.
      setUser(null);
      setLoading(false);
    }
  }, [auth]);

  return { user, loading };
}
